import type { FaireProductEntity } from "../../entity_types/product";

export const p_g3syszptaw: FaireProductEntity = {
  token: "p_g3syszptaw",
  type: "product",
  name: "Arizona Real Sugar PET Sweet Tea 20/16.9OZ",
  brandToken: "b_ktcqb4hfg7",
  brandName: "L&F Universal Goods",
  imageUrl:
    "https://cdn.faire.com/fastly/bc46916df279e491f19a0aafece1d2fc9cab4134880eadd871ca3bf295d65c5a.jpeg",
  galleryImageUrls: [],
  priceDollars: 40.18,
  description: "Southern-style sweet tea made with natural sweetener.",
  tags: [],
  msrpDollars: 78.98,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:49:34.370Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
